// extracted by mini-css-extract-plugin
export default {"icon":"L9v4+mCkBY","hint":"VdEP6KBQPr"};